export enum EBannerStateType {
  REGISTERED = 'Registrado',
  ACTIVE = 'Activo',
  INACTIVE = 'Inactivo',
  EXPIRED = 'Expirado',
}

export enum EBannerType {
  /**
   * ## INFORMATIVO
   */
  INFORMATIVE = 1,
  /**
   * ## LINK
   *
   * This type of banner is used to redirect users to a specific URL.
   *
   * It requires a URL to redirect to and can optionally be used for loyalty programs.
   */
  LINK = 2,
  /**
   * ## POPUP
   *
   * When this type is selected, the `popupImagePath` property must be provided.
   */
  POPUP = 3,
  /**
   * ## PROMOCIONAL
   *
   * When this type is selected, the `promotionExternalIds` property must be provided.
   */
  PROMOTIONAL = 4,
  /**
   * ## LOYALTY
   *
   * This type is used for loyalty banners, which may have specific requirements or behaviors.
   */
  LOYALTY = 5,
}
/**
 * ### Banner target types.
 */
export enum EBannerTarget {
  /**
   * Banner by segment, which includes distributors, price lists, and excluded customers.
   */
  SEGMENT = 1,
  /**
   * Banner by customer list, which includes specific customer codes.
   */
  CUSTOMER_LIST = 2,
}
export enum EBannerTab {
  CREATION = 1,
  VISUALIZATION = 2,
}
